import { STORE_RENDER_FORM_TRIGGER, CLEAR_RENDER_FORM_TRIGGER } from '../constants/Constants';

export const renderFormTriggerReducer = (state : any = {triggers : {}}, action) => {
    switch (action.type) {
      case STORE_RENDER_FORM_TRIGGER:
      {
        return {
          triggers : {...state.triggers, [action.payload.triggerName] : true}
        };
      }        
      case CLEAR_RENDER_FORM_TRIGGER:
        return {
          triggers : {}
        };
      default:
        return state;
    }
};